import { Button } from "antd";
import styled from "styled-components";

export const ExpandChildrenButton = styled(Button)`
  &.ant-btn.ant-btn-icon-only {
    width: auto;
    padding-right: 8px;
  }
`;
